import React from 'react'
import p from 'prop-types'
import cx from 'classnames'

import { Collection, Group } from '../../components/details/collection'
import { DataCard, DarkBlueBadge, TealBadge, OptionsMenu } from '../data-card/data-card-parts'
import { Button, CollectionButton } from '../buttons'

const ReportCard = ({
  id,
  name,
  filePath,
  sizeKb,
  requestedAt,
  lastDownloadedAt,
  downloadCount,

  downloadReport,
  deleteReport,
  disabled = false
}) => (
  <DataCard style={{marginBottom: '10px'}}>
    <OptionsMenu optionItems={[
      {
        name: 'Download',
        action: () => { downloadReport(id) }
      },
      {
        name: 'Delete',
        action: () => { deleteReport(id) }
      },
    ]} />
    <p>
      <div dangerouslySetInnerHTML={{__html: name}} />
      <DarkBlueBadge text={`${sizeKb} Kb`} />
      {downloadCount === 0 ? <TealBadge text="new!"/> : null}
    </p>
    <p>Requested at: {requestedAt.format('MMMM D, YYYY, hh:mm')}</p>
    { downloadCount > 0 ?
        <p className='small'>Downloaded {downloadCount} times. Last downloaded: {lastDownloadedAt.format('MMMM D, hh:mm')}</p>
        : '0 Downloads'
    }
  </DataCard>
)

export default ({
  reports,
  downloadReport,
  deleteReport,

  hasNextPage,
  onLoadNextPage
}) => (
  <div>
    <Collection constraints={{ width: '595px' }}>
      <Group title="Reports">
        {reports && 
          reports.map( (report) => {
            return (
              <ReportCard
                key={report.id}
                {...report}
                downloadReport={downloadReport}
                deleteReport={deleteReport}
              />
            ) 
          }
        )}
      </Group>

      {hasNextPage &&
        <CollectionButton onClick={onLoadNextPage}>See more...</CollectionButton>}
    </Collection>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/reports/reports.js